// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"1900c94a","171":"0c8e3b25","453":"e333520d"}[chunkId] + ".chunk.js";
};